import { createContext, useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import MyActivitiesHome from "../views/MyActivitiesHome";
import MySubjects from "../views/MySubjects";
import MyExamCycles from "../views/MyExamCycles";
import { callApi } from "../Helpers";


export default function MyActivities(props) {

	const appContext = useContext(AppContext);
	

	const [view, setView] = useState(null);
	

	async function init() {
		//run initializations here
		
	}

	

	function getView() {
		if (
			!appContext.navSubItem &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <MyActivitiesHome />
		} else if (
			appContext.navSubItem === 'my_subjects' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <MySubjects />
		} else if (
			appContext.navSubItem === 'my_exam_cycles' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <MyExamCycles />
		}

		return null;
	}

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		const _view = getView();
		if (_view) {
			setView(_view);
		}
	}, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem])

	
	//return desired view
	return view;
}